import styled from 'styled-components';
import { Box, Flex, Headline, mediaQueries, Script as SliceScript, Text as SliceText } from '@lce/slice';

interface props {
  isThin: boolean;
}

export const LtoText = styled(Box)<props>`
  margin: 0 auto 20px auto;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  ${mediaQueries[1]} {
    min-width: 280px;
    max-width: ${({ isThin }) => (isThin ? '414px' : 'inherit')};
    margin: 2.5rem 0 1.25rem 0;
  }
`;

export const Hnr = styled(Flex)`
  align-items: center;
  white-space: nowrap;
  margin-bottom: -12px;
  justify-content: center;

  ${mediaQueries[1]} {
    justify-content: inherit;
  }
`;

export const RegMark = styled(SliceText)<props>`
  font-size: 0.5em;
  display: 'inline-block';
  margin-top: -20px;
`;

export const HnrSymbol = styled.sup<props>`
  font-size: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.mrEaves};

  ${mediaQueries[1]} {
    font-size: 0.75rem;
  }
`;

export const Script = styled(SliceScript)`
  color: ${({ theme }) => theme.colors.black};
  font-size: 32px;

  ${mediaQueries[1]} {
    font-size: 36px;
  }
`;

export const Hours = styled(SliceText)`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.25rem;

  ${mediaQueries[1]} {
    font-size: 1.5rem;
  }
`;

export const Heading = styled(Headline)<props>`
  display: block;
  font-size: 4rem;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  line-height: 0.8;
  margin-bottom: 8px;
  font-weight: ${({ isThin }) => (isThin ? 'normal' : 'bold')};

  ${mediaQueries[0]} {
    margin-bottom: 4px;
    font-size: 4rem;
  }

  ${mediaQueries[1]} {
    text-align: left;
    font-size: 4rem;
    width: 381px;
  }

  ${mediaQueries[2]} {
    font-size: ${({ isThin }) => (isThin ? '6.25rem' : '5.75rem')};
    width: 512px;
  }
`;

export const HeadingSymbol = styled.sup`
  font-size: 2rem;
`;

export const Subheading = styled(Headline)<props>`
  display: block;
  font-size: 3.25rem;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  line-height: 0.8;
  margin-bottom: 10px;
  font-weight: ${({ isThin }) => (isThin ? 'normal' : 'bold')};

  ${mediaQueries[0]} {
    font-size: 3.25rem;
    margin-bottom: 4px;
  }

  ${mediaQueries[1]} {
    text-align: left;
    font-size: 3rem;
  }

  ${mediaQueries[2]} {
    font-size: 4rem;
  }
`;

export const SubheadingSymbol = styled.sup`
  font-size: 1.5rem;
`;

export const TextWrapper = styled(Flex).attrs(({ isThin }: props) => ({
  flexDirection: 'row',
  justifyContent: isThin ? ['center', 'center', 'center'] : ['center', 'center', 'initial'],
  mt: isThin ? 0 : [0, 2],
  flexWrap: 'wrap',
}))<props>``;

export const Text = styled(SliceText)<props>`
  display: block;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.75rem;
  text-align: center;
  line-height: 1;
  font-weight: bold;

  ${mediaQueries[1]} {
    font-size: ${({ isThin }) => (isThin ? '1.5rem' : '2.25rem')};
    text-align: left;
  }
`;

export const TextRegMark = styled(SliceText).attrs({
  mt: ['-4px', 0],
})`
  font-family: ${({ theme }) => theme.fonts.mrEaves};
  font-size: 0.35em;
  display: 'inline-block';
  text-transform: uppercase;
  vertical-align: super;
`;

export const TextSymbol = styled.sup`
  font-size: 1rem;
`;
